import React, { Component } from "react";

import { Translate } from "react-redux-i18n";

import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import ArrowCardToggle from "../../../utils/components/ArrowCardToggle";

import "../../../../styles/components/legal/Legal.scss";
import evio from "../../../../styles/images/evio.svg";

class TermsAndConditions extends Component {
  state = {};
  render() {
    return (
      <div id="tc">
        <div className="evio-logo">
          <img src={evio} alt="" />
        </div>
        <div className="tc-text">
          <Translate value="legalTC_text" />
        </div>
        <Accordion>
          <Card>
            <ArrowCardToggle eventKey="0">
              <Translate value="legalTC_servicesTitle" />
            </ArrowCardToggle>
            <Accordion.Collapse eventKey="0">
              <Card.Body>
                <Translate value="legalTC_servicesText" />
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <ArrowCardToggle eventKey="1">
              <Translate value="legalTC_dataPolicyTitle" />
            </ArrowCardToggle>
            <Accordion.Collapse eventKey="1">
              <Card.Body>
                <Translate value="legalTC_dataPolicyText" />
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <ArrowCardToggle eventKey="2">
              <Translate value="legalTC_additionalRightsTitle" />
            </ArrowCardToggle>
            <Accordion.Collapse eventKey="2">
              <Card.Body>
                <Translate value="legalTC_additionalRightsText" />
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      </div>
    );
  }
}

export default TermsAndConditions;
